import { Dialog, DialogActions, DialogContent } from "@mui/material";
import { ContractModificationTypes, Contract, ContractDisplayTypes, IElecContract } from "../../types/contracts";

import ChangeAddress from "./components/ChangeAddress";
import ChangeIban from "./components/ChangeIban";
import ChangePower from './components/ChangePower';
import ReclamATC from "../../../ReclamATC/components/ReclamATC";
import NoSIPSCession from "./components/NoSIPSCession";
import ChangeRefCatastral from "./components/ChangeRefCatastral";
import ChangeInvoiceOnline from "./components/ChangeInvoiceOnline";
import ContractElectronicNotification from '../DetailsPanels/components/ElectronicNotificationAction';

interface IModificationDialogProps {
  contract: Contract,
  formContent: ContractModificationTypes,
  type: ContractDisplayTypes,
  handleDialogClose: () => void
}

const ModificationDialog = ({
  contract,
  formContent,
  type,
  handleDialogClose
}: IModificationDialogProps) => {

  return <Dialog
    open={!!formContent}
    onClose={handleDialogClose}
    fullWidth={true}
    maxWidth={'lg'}
  >        
    {formContent === "noSIPSCession" && <NoSIPSCession
      contractName={contract.name}
      isWaitingForSignature={contract.no_cession_sips.waiting_for_signature}
      type={type}
      onDialogClose={handleDialogClose}
    />}
    {formContent === "iban" && <ChangeIban onClose={handleDialogClose} type={contract.type}/>}
    {formContent === "power" && <ChangePower onClose={handleDialogClose}/>}
    {formContent === "refCatastral" && <ChangeRefCatastral type={contract.type} onClose={handleDialogClose}/>}
    {formContent === "address" && <ChangeAddress type={type} onClose={handleDialogClose}/>}
    {formContent === "invoiceOnline" && <ChangeInvoiceOnline type={contract.type} onClose={handleDialogClose}/>}
    {formContent === "reclam" && <ReclamATC />}
    {formContent === "elecNotif" && contract.type === 'electricity' && <ContractElectronicNotification contract={contract} openDirectly={true} actionOnClose={handleDialogClose}/>}
  </Dialog>
}

export default ModificationDialog;